let UTILS = require("../libs/utils.js");
var v7779;
var v7780;
var vA384 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 14, 16, 18, 21, 27];
module.exports = {
  id: "md",
  name: "Mag Dump",
  alias: "md",
  preventCustomGames: true,
  tag: ["Event", "#d95487", "#e86b9b"],
  event: 5,
  endStats: ["sid", "name", "score", "kills", "deaths", "pickups", "reward"],
  leaderStats: ["score", "kills", "pickups"],
  onKill: function (p9301, p9302, p9303, p9304) {
    if (p9304 && p9304 != p9303) {
      var v7781 = p9303.lastGround && !p9303.onGround;
      var vO220 = {
        x: v7781 ? p9303.lastGround.x : p9303.x,
        y: v7781 ? p9303.lastGround.y : p9303.y,
        z: v7781 ? p9303.lastGround.z : p9303.z
      };
      p9301.dropSpawnable(7, p9303, {
        wId: UTILS.getRandom(vA384),
        xD: p9303.xDire + UTILS.toRad(90)
      }, vO220);
      if (UTILS.randInt(1, 100) <= 20) {
        p9301.dropSpawnable(8, p9303, null, {
          x: vO220.x + UTILS.randInt2(3, 8),
          y: vO220.y,
          z: vO220.z + UTILS.randInt2(3, 8)
        });
      }
    }
  },
  doubleXP: true,
  forceSpawn: 3,
  forceClass: 9,
  noReloads: true,
  noPickups: true,
  randClassScr: 0.5,
  noScrLimit: true,
  noKnives: true,
  startingLoadout: [2],
  disabledStreaks: [4, 5, 6]
};